import { NSInfo } from '../types'

export const createNamespaces = <T extends string>(
  items: Record<T, NSInfo>
) => {
  return items
}
